// From Iconoir — used via Iconify (https://iconify.design)
import type { SVGProps } from "react";

export function BookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5"><path d="M4 19V5a2 2 0 0 1 2-2h13.4a.6.6 0 0 1 .6.6v13.114M6 17h14M6 21h14"/><path strokeLinejoin="round" d="M6 21a2 2 0 1 1 0-4"/><path d="M9 7h6"/></g>
    </svg>
  );
}
